import { render, staticRenderFns } from "./selectFields.vue?vue&type=template&id=4cd876ac"
import script from "./selectFields.vue?vue&type=script&lang=js"
export * from "./selectFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports